/* Latifa theme — vanilla JS, no dependencies */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const T = window.theme || { routes: {}, strings: {} };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const fmt = T.moneyFormat || '{{amount_with_comma_separator}} TL';
    const n = (cents / 100);
    const withComma = n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const noDec = Math.round(n).toLocaleString('tr-TR');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount\s*\}\}/, n.toLocaleString('en-US', { minimumFractionDigits: 2 }));
  }
  window.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  let toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), 2400);
  }
  window.themeToast = toast;

  /* ---------- Drawers ---------- */
  const overlay = $('[data-overlay]');
  let openDrawer = null;
  function open(id) {
    const d = document.getElementById(id);
    if (!d) return;
    close();
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    overlay && overlay.classList.add('is-active');
    document.body.classList.add('no-scroll');
    openDrawer = d;
    const f = d.querySelector('input[type="search"], button, a');
    f && setTimeout(() => f.focus(), 250);
  }
  function close() {
    if (!openDrawer) return;
    openDrawer.classList.remove('is-open');
    openDrawer.setAttribute('aria-hidden', 'true');
    overlay && overlay.classList.remove('is-active');
    document.body.classList.remove('no-scroll');
    openDrawer = null;
  }
  window.themeDrawer = { open, close };
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); open(o.dataset.open); return; }
    if (e.target.closest('[data-close]') || e.target === overlay) close();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); $$('.modal.is-open,.zoom.is-open,.popup.is-open').forEach(m => m.classList.remove('is-open')); document.body.classList.remove('no-scroll'); } });

  /* ---------- Header ---------- */
  const hw = $('.header-wrap');
  if (hw) {
    const setH = () => document.documentElement.style.setProperty('--header-h', hw.offsetHeight + 'px');
    setH(); window.addEventListener('resize', setH);
    const onScroll = () => hw.classList.toggle('is-scrolled', window.scrollY > 40);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    hw.addEventListener('mouseenter', () => hw.classList.add('is-hovered'));
    hw.addEventListener('mouseleave', () => hw.classList.remove('is-hovered'));
  }

  /* ---------- Cart ---------- */
  async function fetchCart() { const r = await fetch(T.routes.cart_url + '.js'); return r.json(); }
  async function refreshCartDrawer(openIt) {
    try {
      const r = await fetch(T.routes.root_url.replace(/\/$/, '') + '/?sections=cart-drawer');
      const data = await r.json();
      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const fresh = html.querySelector('#CartDrawer');
      const cur = $('#CartDrawer');
      if (fresh && cur) { cur.innerHTML = fresh.innerHTML; }
      const cart = await fetchCart();
      $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
      if (openIt) open('CartDrawer');
    } catch (e) { location.href = T.routes.cart_url; }
  }
  window.refreshCart = refreshCartDrawer;

  async function addToCart(id, qty = 1, btn) {
    btn && btn.classList.add('is-loading');
    try {
      const r = await fetch(T.routes.cart_add_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
      });
      const j = await r.json();
      if (!r.ok) { toast(j.description || T.strings.error); return; }
      await window.refreshCart(true);
    } catch (e) { toast(T.strings.error); }
    finally { btn && btn.classList.remove('is-loading'); }
  }
  window.addToCart = addToCart;

  async function changeLine(key, qty) {
    const r = await fetch(T.routes.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    if (!r.ok) { const j = await r.json(); toast(j.description || T.strings.error); }
    if (document.body.classList.contains('template-cart')) { location.reload(); return; }
    refreshCartDrawer(false);
  }

  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-qty-change]');
    if (q) {
      e.preventDefault();
      const wrap = q.closest('[data-line]');
      const input = wrap.querySelector('input');
      const v = Math.max(0, Number(input.value) + Number(q.dataset.qtyChange));
      input.value = v; changeLine(wrap.dataset.line, v); return;
    }
    const rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.dataset.remove, 0); return; }
    const qa = e.target.closest('[data-quick-add]');
    if (qa) { e.preventDefault(); addToCart(qa.dataset.quickAdd, 1, qa); }
  });
  document.addEventListener('change', (e) => {
    const i = e.target.closest('[data-line] input');
    if (i) changeLine(i.closest('[data-line]').dataset.line, Math.max(0, Number(i.value)));
  });

  /* ---------- Wishlist (local, per browser) ---------- */
  const WKEY = 'latifa_wishlist';
  const getW = () => { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } };
  const setW = (a) => { try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {} };
  function paintWish() { const w = getW(); $$('[data-wish]').forEach(b => b.classList.toggle('is-active', w.includes(b.dataset.wish))); $$('[data-wish-count]').forEach(c => c.textContent = w.length || ''); }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    let w = getW(); const h = b.dataset.wish;
    w = w.includes(h) ? w.filter(x => x !== h) : [h, ...w].slice(0, 60);
    setW(w); paintWish();
  });
  paintWish();
  const wl = $('[data-wishlist-grid]');
  if (wl) {
    const w = getW();
    if (!w.length) { $('[data-wishlist-empty]').hidden = false; }
    Promise.all(w.map(h => fetch(T.routes.root_url.replace(/\/$/, '') + '/products/' + h + '?view=card').then(r => r.ok ? r.text() : '').catch(() => '')))
      .then(cards => { wl.innerHTML = cards.join(''); paintWish(); });
  }

  /* ---------- Recently viewed ---------- */
  const RKEY = 'latifa_recent';
  const cur = $('[data-product-handle]');
  if (cur) {
    try {
      let r = JSON.parse(localStorage.getItem(RKEY)) || [];
      r = [cur.dataset.productHandle, ...r.filter(x => x !== cur.dataset.productHandle)].slice(0, 12);
      localStorage.setItem(RKEY, JSON.stringify(r));
    } catch (e) {}
  }
  const rv = $('[data-recent-grid]');
  if (rv) {
    let r = []; try { r = JSON.parse(localStorage.getItem(RKEY)) || []; } catch (e) {}
    r = r.filter(h => !cur || h !== cur.dataset.productHandle).slice(0, 8);
    if (r.length) {
      Promise.all(r.map(h => fetch(T.routes.root_url.replace(/\/$/, '') + '/products/' + h + '?view=card').then(x => x.ok ? x.text() : '').catch(() => '')))
        .then(cards => { rv.innerHTML = cards.join(''); rv.closest('section').hidden = false; paintWish(); });
    }
  }

  /* ---------- Carousels ---------- */
  $$('[data-carousel]').forEach(c => {
    const track = $('.carousel__track', c);
    const step = () => track.clientWidth * 0.8;
    $$('[data-prev]', c.parentElement).forEach(b => b.addEventListener('click', () => track.scrollBy({ left: -step() })));
    $$('[data-next]', c.parentElement).forEach(b => b.addEventListener('click', () => track.scrollBy({ left: step() })));
  });

  /* ---------- Hero slider ---------- */
  $$('[data-hero-slider]').forEach(h => {
    const track = $('.hero__track', h); const slides = $$('.hero__slide', h); const dots = $$('.hero__dots button', h);
    if (slides.length < 2) return;
    let i = 0; const ms = Number(h.dataset.autoplay || 0) * 1000;
    const go = (n) => { i = (n + slides.length) % slides.length; track.style.transform = `translateX(-${i * 100}%)`; dots.forEach((d, k) => d.classList.toggle('is-active', k === i)); };
    dots.forEach((d, k) => d.addEventListener('click', () => go(k)));
    let x0 = null;
    h.addEventListener('touchstart', e => x0 = e.touches[0].clientX, { passive: true });
    h.addEventListener('touchend', e => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
    if (ms) { let t = setInterval(() => go(i + 1), ms); h.addEventListener('mouseenter', () => clearInterval(t)); h.addEventListener('mouseleave', () => t = setInterval(() => go(i + 1), ms)); }
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -10% 0px' });
    $$('.reveal').forEach(el => io.observe(el));
  } else { $$('.reveal').forEach(el => el.classList.add('is-in')); }

  /* ---------- SEO text toggle ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-seo-toggle]');
    if (!t) return;
    const box = t.closest('.seo-text'); box.classList.toggle('is-open');
    t.textContent = box.classList.contains('is-open') ? t.dataset.less : t.dataset.more;
  });

  /* ---------- Modals ---------- */
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-modal]');
    if (o) { e.preventDefault(); const m = document.getElementById(o.dataset.modal); m && m.classList.add('is-open'); document.body.classList.add('no-scroll'); return; }
    if (e.target.closest('[data-modal-close]')) { const m = e.target.closest('.modal,.zoom,.popup'); m && m.classList.remove('is-open'); document.body.classList.remove('no-scroll'); }
  });

  /* ---------- Predictive search ---------- */
  const sInput = $('[data-predictive-input]');
  const sOut = $('[data-predictive-results]');
  if (sInput && sOut) {
    let timer;
    sInput.addEventListener('input', () => {
      clearTimeout(timer);
      const q = sInput.value.trim();
      if (q.length < 2) { sOut.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        try {
          const r = await fetch(`${T.routes.predictive_search_url}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product&resources[limit]=8`);
          const t = await r.text();
          const d = new DOMParser().parseFromString(t, 'text/html').querySelector('#shopify-section-predictive-search');
          sOut.innerHTML = d ? d.innerHTML : '';
        } catch (e) {}
      }, 250);
    });
  }

  /* ---------- Collection: filters & columns ---------- */
  const fForm = $('[data-filter-form]');
  if (fForm) {
    fForm.addEventListener('change', (e) => { if (window.innerWidth > 989 || e.target.closest('[data-instant]')) fForm.requestSubmit ? fForm.requestSubmit() : fForm.submit(); });
  }
  const sortSel = $('[data-sort]');
  if (sortSel) sortSel.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page'); location.href = u.toString(); });
  $$('[data-cols]').forEach(b => b.addEventListener('click', () => {
    const g = $('[data-product-grid]'); if (!g) return;
    const n = b.dataset.cols; const mobile = window.innerWidth < 750;
    g.style.setProperty(mobile ? '--cols-m' : '--cols-d', n);
    $$('[data-cols]').forEach(x => x.classList.toggle('is-active', x === b));
    try { localStorage.setItem('latifa_cols_' + (mobile ? 'm' : 'd'), n); } catch (e) {}
  }));
  (function restoreCols() {
    const g = $('[data-product-grid]'); if (!g) return;
    try {
      const m = window.innerWidth < 750; const v = localStorage.getItem('latifa_cols_' + (m ? 'm' : 'd'));
      if (v) { g.style.setProperty(m ? '--cols-m' : '--cols-d', v); $$('[data-cols]').forEach(x => x.classList.toggle('is-active', x.dataset.cols === v)); }
    } catch (e) {}
  })();
  // Infinite load more
  const more = $('[data-load-more]');
  if (more && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(async (es) => {
      if (!es[0].isIntersecting || more.dataset.loading) return;
      const url = more.dataset.next; if (!url) return;
      more.dataset.loading = '1';
      const html = new DOMParser().parseFromString(await (await fetch(url)).text(), 'text/html');
      const items = $$('[data-product-grid] > *', html);
      const g = $('[data-product-grid]'); items.forEach(i => g.appendChild(i));
      const nm = $('[data-load-more]', html);
      if (nm && nm.dataset.next) { more.dataset.next = nm.dataset.next; more.innerHTML = nm.innerHTML; delete more.dataset.loading; }
      else { more.remove(); io.disconnect(); }
      paintWish();
    }, { rootMargin: '600px' });
    io.observe(more);
  }

  /* ---------- Newsletter popup ---------- */
  const pop = $('[data-popup]');
  if (pop) {
    let seen = false; try { seen = sessionStorage.getItem('latifa_pop') || localStorage.getItem('latifa_pop_done'); } catch (e) {}
    if (!seen) setTimeout(() => { pop.classList.add('is-open'); try { sessionStorage.setItem('latifa_pop', '1'); } catch (e) {} }, Number(pop.dataset.delay || 6) * 1000);
  }
})();

/* ---------- Product form (custom element) ---------- */
class ProductForm extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.form = this.querySelector('form');
    this.idInput = this.form.querySelector('[name="id"]');
    this.btn = this.form.querySelector('[data-atc]');
    this.sticky = document.querySelector('[data-sticky-atc]');
    this.form.addEventListener('change', () => this.onChange());
    this.form.addEventListener('submit', (e) => this.onSubmit(e));
    this.paintAvailability();
    this.onChange(true);
    if (this.sticky) {
      const upd = () => this.sticky.classList.toggle('is-visible', this.btn.getBoundingClientRect().bottom < 0);
      window.addEventListener('scroll', upd, { passive: true }); upd();
      this.sticky.querySelector('button').addEventListener('click', () => {
        if (!this.current) { this.btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); window.themeToast(window.theme.strings.selectSize); return; }
        this.btn.click();
      });
    }
  }
  selected() { return Array.from(this.form.querySelectorAll('[data-option]')).map(fs => { const c = fs.querySelector('input:checked'); return c ? c.value : null; }); }
  paintAvailability() {
    // grey-out sizes with no stock given the other selected options
    const sel = this.selected();
    this.form.querySelectorAll('[data-option]').forEach((fs, idx) => {
      fs.querySelectorAll('input').forEach(inp => {
        const ok = this.variants.some(v => v.available && v.options[idx] === inp.value && v.options.every((o, j) => j === idx || !sel[j] || sel[j] === o));
        inp.classList.toggle('is-unavailable', !ok);
      });
    });
  }
  onChange(initial) {
    const sel = this.selected();
    const v = sel.includes(null) ? null : this.variants.find(x => x.options.every((o, i) => o === sel[i]));
    this.current = v;
    this.paintAvailability();
    const label = this.btn.querySelector('span');
    if (!v) { this.idInput.value = ''; label.textContent = this.variants.length > 1 ? window.theme.strings.selectSize : window.theme.strings.soldOut; this.btn.disabled = this.variants.length <= 1; return; }
    this.idInput.value = v.id;
    this.btn.disabled = !v.available;
    label.textContent = v.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
    const pe = this.querySelector('[data-pdp-price]') || document.querySelector('[data-pdp-price]');
    const inst = this.querySelector('[data-installment]');
    if (inst && !initial) inst.textContent = window.formatMoney(Math.round(v.price / Number(inst.dataset.n || 3)));
    if (pe && pe.hasAttribute('data-lt') && !initial) {
      const sale = v.compare_at_price > v.price;
      pe.innerHTML = (sale ? `<s>${window.formatMoney(v.compare_at_price)}</s>` : '') + `<span class="now">${window.formatMoney(v.price)}</span>`;
    } else if (pe && !initial) {
      const sale = v.compare_at_price > v.price;
      pe.innerHTML = `<div class="price${sale ? ' price--sale' : ''}"><span class="price__current">${window.formatMoney(v.price)}</span>${sale ? `<s class="price__compare">${window.formatMoney(v.compare_at_price)}</s><span class="price__pct">-%${Math.round((1 - v.price / v.compare_at_price) * 100)}</span>` : ''}</div>`;
    }
    const sku = this.querySelector('[data-sku]'); if (sku) sku.textContent = v.sku || '';
    const st = this.querySelector('[data-stock]');
    if (st) { const q = v.inventory_quantity; const low = Number(st.dataset.threshold || 3); if (v.available && q > 0 && q <= low && v.inventory_management) { st.textContent = st.dataset.text.replace('XX', q); st.hidden = false; } else st.hidden = true; }
    if (!initial && history.replaceState && !this.closest('.lt-qv')) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
  }
  async onSubmit(e) {
    e.preventDefault();
    if (!this.current) { window.themeToast(window.theme.strings.selectSize); return; }
    await window.addToCart(this.current.id, Number(this.form.querySelector('[name="quantity"]')?.value || 1), this.btn);
  }
}
if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);

/* ---------- Product gallery: dots + zoom ---------- */
document.querySelectorAll('[data-gallery]').forEach(g => {
  const dots = document.querySelectorAll('[data-gallery-dots] i');
  g.addEventListener('scroll', () => { const i = Math.round(g.scrollLeft / g.clientWidth); dots.forEach((d, k) => d.classList.toggle('is-active', k === i)); }, { passive: true });
  g.addEventListener('click', (e) => {
    const m = e.target.closest('.pdp__media'); if (!m) return;
    const z = document.getElementById('Zoom'); if (!z) return;
    z.classList.add('is-open'); document.body.classList.add('no-scroll');
    const t = z.querySelectorAll('img')[Number(m.dataset.index || 0)]; t && t.scrollIntoView();
  });
});

/* ---------- Birebir katman: header, sol menü, arama, footer ---------- */
(function () {
  const hdr = document.querySelector('[data-lt-header]');
  if (!hdr) return;
  const isHome = document.body.classList.contains('lt-home');
  const solid = () => hdr.classList.toggle('is-solid', !isHome || window.scrollY > 10 || hdr.matches(':hover') || hdr.querySelector('.lt-search.is-open') !== null);
  solid();
  window.addEventListener('scroll', solid, { passive: true });
  hdr.addEventListener('mouseenter', solid); hdr.addEventListener('mouseleave', () => setTimeout(solid, 10));

  // side menu
  const panel = document.querySelector('[data-lt-side-panel]');
  const shade = document.querySelector('[data-lt-side-close]');
  const burger = hdr.querySelector('[data-lt-side] img');
  const setSide = (on) => {
    panel.classList.toggle('is-open', on); shade.classList.toggle('is-open', on);
    document.body.classList.toggle('lt-side-open', on);
    if (burger) burger.src = on ? burger.dataset.openSrc : burger.dataset.closed;
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-lt-side]')) { e.preventDefault(); setSide(!panel.classList.contains('is-open')); return; }
    if (e.target.closest('[data-lt-side-close]')) setSide(false);
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setSide(false); });

  // search bar under header
  const sbox = hdr.querySelector('[data-lt-search-box]');
  hdr.querySelector('[data-lt-search]').addEventListener('click', () => {
    sbox.classList.toggle('is-open'); solid();
    if (sbox.classList.contains('is-open')) setTimeout(() => sbox.querySelector('input[type=search]').focus(), 150);
  });

  // footer accordions (mobile)
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-lt-fcol]'); if (!t || window.innerWidth > 991) return;
    const col = t.parentElement; col.classList.toggle('is-open');
    const img = t.querySelector('img'); if (img) img.style.transform = col.classList.contains('is-open') ? 'rotate(180deg)' : '';
  });

  // keep header mini cart in sync after ajax cart changes
  const origRefresh = window.refreshCart;
  window.refreshCart = async function (openIt) {
    try {
      const r = await fetch(window.theme.routes.root_url.replace(/\/$/, '') + '/?sections=header');
      const d = await r.json();
      const html = new DOMParser().parseFromString(d.header, 'text/html');
      const fresh = html.querySelector('[data-mini-cart]'); const cur = document.querySelector('[data-mini-cart]');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    } catch (e) {}
    return origRefresh ? origRefresh(openIt) : null;
  };
})();

/* ---------- Birebir katman: kategori, ürün, hızlı bakış ---------- */
(function () {
  const $ = (s, c = document) => c.querySelector(s), $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  // filter panel
  const fp = $('[data-lt-filter-panel]'), fs = $('.lt-filter-shade');
  const setF = (on) => { if (!fp) return; fp.classList.toggle('is-open', on); fs.classList.toggle('is-open', on); document.body.classList.toggle('no-scroll', on); };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-lt-filter]')) { setF(true); return; }
    if (e.target.closest('[data-lt-filter-close]')) { setF(false); return; }
    if (e.target.closest('[data-lt-filter-apply]')) { const f = $('[data-lt-filter-form]'); const p = new URLSearchParams(new FormData(f)); [...p.keys()].forEach(k => { if (p.get(k) === '') p.delete(k); }); location.href = f.action + (p.toString() ? '?' + p : ''); }
  });
  // column switch
  const g = $('[data-lt-grid]');
  $$('[data-lt-cols]').forEach(b => b.addEventListener('click', () => { g.style.setProperty('--cols', b.dataset.ltCols); $$('[data-lt-cols]').forEach(x => x.classList.toggle('is-active', x === b)); try { localStorage.setItem('lt_cols', b.dataset.ltCols); } catch (e) {} }));
  try { const c = localStorage.getItem('lt_cols'); if (g && c && window.innerWidth > 991) { g.style.setProperty('--cols', c); $$('[data-lt-cols]').forEach(x => x.classList.toggle('is-active', x.dataset.ltCols === c)); } } catch (e) {}
  // similar products arrows
  document.addEventListener('click', (e) => { const b = e.target.closest('[data-sim]'); if (!b) return; const t = b.closest('section').querySelector('[data-sim-track]'); t.scrollBy({ left: Number(b.dataset.sim) * t.clientWidth * .75, behavior: 'smooth' }); });
  // pdp gallery arrows (mobile) + zoom (desktop)
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-gal]'); if (a) { const gal = $('[data-gallery]'); gal.scrollBy({ left: Number(a.dataset.gal) * gal.clientWidth, behavior: 'smooth' }); return; }
    const im = e.target.closest('.lt-pdp__gallery img'); if (im && window.innerWidth > 991) { const z = $('#Zoom'); if (!z) return; z.classList.add('is-open'); document.body.classList.add('no-scroll'); const idx = Array.from(im.parentElement.querySelectorAll(':scope > img')).indexOf(im); const t = z.querySelectorAll('img')[Math.max(0, idx)]; t && t.scrollIntoView(); }
  });
  // share
  document.addEventListener('click', (e) => {
    const s = e.target.closest('[data-lt-share]'); if (s) { s.parentElement.querySelector('[data-lt-share-box]').classList.toggle('is-open'); return; }
    const c = e.target.closest('[data-copy]'); if (c) { navigator.clipboard && navigator.clipboard.writeText(c.dataset.copy); window.themeToast && window.themeToast('Link kopyalandı'); return; }
    if (!e.target.closest('[data-lt-share-box]')) $$('[data-lt-share-box].is-open').forEach(x => x.classList.remove('is-open'));
  });
  // size chart
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-lt-size]')) { const m = $('#SizeChart'); m && m.classList.add('is-open'); return; }
    if (e.target.closest('[data-lt-size-close]')) { const m = $('#SizeChart'); m && m.classList.remove('is-open'); }
  });
  // quick view ("+")
  let qv;
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-quick-view]');
    if (b) {
      e.preventDefault();
      if (!qv) { qv = document.createElement('div'); qv.className = 'lt-qv'; qv.innerHTML = '<div class="lt-qv__bg" data-qv-close></div><div data-qv-body></div>'; document.body.appendChild(qv); }
      const r = await fetch(window.theme.routes.root_url.replace(/\/$/, '') + '/products/' + b.dataset.quickView + '?view=quickview');
      qv.querySelector('[data-qv-body]').innerHTML = await r.text();
      qv.classList.add('is-open'); document.body.classList.add('no-scroll');
      return;
    }
    if (qv && e.target.closest('[data-qv-close]')) { qv.classList.remove('is-open'); document.body.classList.remove('no-scroll'); }
  });
})();

/* ---------- Latifa Plus ---------- */
(function () {
  const $ = (s, c = document) => c.querySelector(s), $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  // delivery estimate
  const d = $('[data-deliver]');
  if (d) {
    const cut = Number(d.dataset.cutoff || 16), now = new Date(), day = now.getDay();
    const dayNames = ['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'];
    let ship = new Date(now); let label;
    if (day !== 0 && now.getHours() < cut) { const left = (cut - now.getHours() - 1) + ' sa ' + (60 - now.getMinutes()) + ' dk'; label = `<b class="green">Ücretsiz kargo</b> · <b>${left}</b> içinde sipariş verin, <b>bugün kargoda</b>`; }
    else { ship.setDate(ship.getDate() + (day === 6 ? 2 : 1)); label = `<b class="green">Ücretsiz kargo</b> · <b>${dayNames[ship.getDay()]}</b> günü kargoda`; }
    const a = new Date(ship); a.setDate(a.getDate() + 1); const b = new Date(ship); b.setDate(b.getDate() + 3);
    const f = x => x.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long' });
    $('[data-deliver-text]').innerHTML = label + `<br>Tahmini teslimat: <b>${f(a)} – ${f(b)}</b>`;
  }
  // product row tabs
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-row-tab]'); if (!t) return;
    const sec = t.closest('[data-lt-row]'); const i = t.dataset.rowTab;
    $$('[data-row-tab]', sec).forEach(x => x.classList.toggle('is-active', x === t));
    $$('[data-row-panel]', sec).forEach(x => x.hidden = x.dataset.rowPanel !== i);
    $$('[data-row-link]', sec).forEach(x => x.hidden = x.dataset.rowLink !== i);
  });
  // mobile 1/2 columns
  const g = $('[data-lt-grid]');
  $$('[data-lt-mcols]').forEach(b => b.addEventListener('click', () => { g.classList.toggle('is-two', b.dataset.ltMcols === '2'); $$('[data-lt-mcols]').forEach(x => x.classList.toggle('is-active', x === b)); try { localStorage.setItem('lt_mcols', b.dataset.ltMcols); } catch (e) {} }));
  try { if (g && localStorage.getItem('lt_mcols') === '2') { g.classList.add('is-two'); $$('[data-lt-mcols]').forEach(x => x.classList.toggle('is-active', x.dataset.ltMcols === '2')); } } catch (e) {}
  // sort select (desktop bar)
  const so = $('.lt-coll__sort'); if (so) so.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', so.value); location.href = u; });
  // cart page: coupon → checkout with discount
  const cf = $('[data-coupon]'); if (cf) { const go = () => { const c = cf.querySelector('input').value.trim(); if (!c) return; location.href = '/checkout?discount=' + encodeURIComponent(c); }; cf.querySelector('[data-coupon-apply]').addEventListener('click', go); cf.querySelector('input').addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); go(); } }); }
  // quick add from card: stop link navigation
  document.addEventListener('click', (e) => { if (e.target.closest('.lt-card__sizes')) e.preventDefault(); }, true);
})();
